import React, { ReactElement } from 'react';

import EditorLayout from 'app/developer-v3/layouts/EditorLayout';
import { getActionUrl, isNewServiceField } from 'app/developer-v3/utils';

import type { AppDefinitionProps } from 'app/developer-v3/types';
import type { SemVer } from 'app/developer-v3/types/version';

type Props = AppDefinitionProps & {
  children: ReactElement;
  currentUrl: string;
  currentActionLabel: string;
  params: {
    id: string;
    version: SemVer;
    actionKey: string;
  };
};

const ActionEditor = ({
  children,
  currentActionLabel,
  currentUrl,
  params,
}: Props) => {
  const actionUrl = getActionUrl(params);
  const isNewAction = isNewServiceField(params.actionKey);
  const navItems = [
    { text: 'Settings', href: `${actionUrl}/settings` },
    {
      text: 'Input Designer',
      href: `${actionUrl}/input`,
      disabled: isNewAction,
    },
    {
      text: 'API Configuration',
      href: `${actionUrl}/api`,
      disabled: isNewAction,
    },
  ];

  return (
    <EditorLayout
      currentUrl={currentUrl}
      navConfig={navItems}
      title={`${currentActionLabel} Action`}
    >
      {children}
    </EditorLayout>
  );
};

ActionEditor.displayName = 'ActionEditor';

export default ActionEditor;
